<template>
  <div class="root">
    <div style="flex:1">
      <div class="header">
        <div class="header-date">
          <h1>{{ selectedMonth + ' ' + currentYear }}</h1>
        </div>
        <div class="right" @click="setNextMonth"></div>
        <div class="left" @click="setPrevMonth"></div>
      </div>
      <div class="week header">
        <div
          class="day-header"
          v-for="(staticDay, index) in staticDays"
          :key="index"
        >
          {{ staticDay }}
        </div>
      </div>
      <div class="month">
        <div class="week" v-for="(week, index) in weeks" :key="index">
          <div :class="day.state" v-for="(day, index) in week" :key="index">
            <div class="day-number" :class="dayClass(day)">{{ day.num }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="event-group">
      <div class="loader" v-if="loading" />
      <div v-else-if="monthlyEvents.length === 0">
        No Events Found for this month
      </div>
      <div
        class="event-box"
        v-for="(ev, idx) in monthlyEvents"
        :key="idx"
        v-else
      >
        <div class="event-box-date">
          <div>{{ ev.day }}</div>
          <div>{{ ev.month }}</div>
        </div>
        <div class="event-box-desc">{{ ev.name }}</div>
        <i
          class="fas fa-edit event-edit"
          v-if="profile.role === 'admin'"
          @click="$emit('onClickEvent', ev)"
        ></i>
      </div>
    </div>
  </div>
</template>

<script>
import { http } from '../../digilib_web/core/digitify';
import BaseCalendar from './base_calendar';

export default {
  props: {
    profile: Object
  },
  extends: BaseCalendar,
  watch: {
    currentYear(n, o) {
      this.reloadEvents();
    }
  },
  methods: {
    dayClass(day) {
      let hasEvent = this.events.find(x => x.date === day.formatted)
        ? 'event'
        : '';
      return `${day.isToday ? 'today' : ''} ${hasEvent}`;
    },
    reloadEvents() {
      this.loading = true;
      let y = this.currentYear;
      http.get(`calendars/${y}`).then(json => {
        this.events = json.data;
        this.loading = false;
      });
    }
  }
};
</script>

<style scoped>
.root {
  display: -webkit-flex;
  display: flex;
  height: 100%;
}
.header {
  text-align: center;
  position: relative;
}
.header-date {
  display: -webkit-flex;
  display: flex;
  align-items: center;
  justify-content: center;
}
.header-date h1,
.header-date input {
  padding-left: 5px;
  padding-right: 5px;
  font-size: 19px;
  letter-spacing: 1px;
  font-weight: 100;
}
.header-date input {
  background: transparent;
  border: none;
  width: 60px;
}
.left,
.right {
  position: absolute;
  width: 0px;
  height: 0px;
  border-style: solid;
  top: 50%;
  margin-top: -7.5px;
  cursor: pointer;
}
.left {
  border-width: 7.5px 10px 7.5px 0;
  border-color: transparent rgba(160, 159, 160, 1) transparent transparent;
  left: 20px;
}
.right {
  border-width: 7.5px 0 7.5px 10px;
  border-color: transparent transparent transparent rgba(160, 159, 160, 1);
  right: 20px;
}
.week {
  display: -webkit-flex;
  display: flex;
}
.week.header {
  border: 0.5px solid #dedede;
  border-width: 1px 0 1px 0;
  padding-top: 15px;
  padding-bottom: 15px;
}
.day,
.day-header {
  flex: 1;
  text-align: center;
}
.day {
  cursor: pointer;
  display: flex;
  justify-content: center;
  padding-top: 10px;
}
.day.other {
  color: #bdc3c7;
}
.day-number {
  font-size: 0.85em;
  letter-spacing: 1.5px;
  width: 32px;
  height: 32px;
}
.day-number.today {
  color: white;
  border-radius: 20px;
  background: #62b7a6;
}
.day-number.event {
  /* color: #62b7a6; */
  border-radius: 20px;
  border: 2px solid #62b7a6;
}
.event-group {
  display: -webkit-flex;
  display: flex;
  flex-flow: column;
  margin: 0 0 0 10px;
  overflow-y: auto;
  width: 200px;
}
.event-box {
  border-style: solid;
  border-color: #dedede;
  border-width: 0.5px 0.5px 0.5px 5px;
  border-left-color: #62b7a6;
  display: flex;
  align-items: center;
  padding: 5px;
  margin-bottom: 10px;
  min-height: 50px;
  justify-content: space-between;
}
.event-box-date {
  width: 40px;
  font-weight: bold;
  margin-right: 10px;
  text-align: center;
}
.event-box-desc {
  flex: 1;
}
.event-edit {
  color: #36d7b7;
  cursor: pointer;
}
@media all and (max-width: 640px) {
  .root {
    flex-flow: column;
    max-height: 700px;
  }
  .event-group {
    margin: 0;
    padding-top: 10px;
    width: auto;
  }
}
</style>
